import key from 'weak-key';

// styles
import styles from './media-overlay.module.scss';

// types
import type { MediaItem } from './types';

// components
import { VideoContent } from './video-content';
import { ImageContent } from './image-content';

// utils
import { previewId } from 'utils/preview-id';

type CarouselItemProps = {
  mediaItem: MediaItem;
  itemIndex: number;
  getImage: (item: MediaItem) => any;
};

export function CarouselItem({ mediaItem, itemIndex, getImage }: Readonly<CarouselItemProps>) {
  const videoData = (mediaItem as any)?.video;
  const isVideoItem = Boolean(videoData);

  return (
    <div {...previewId(`#${itemIndex}`)} key={key(mediaItem)} className={styles.listItem}>
      {isVideoItem ? (
        <VideoContent mediaItem={mediaItem} />
      ) : (
        <ImageContent mediaItem={mediaItem} getImage={getImage} />
      )}
    </div>
  );
}
